import { render, staticRenderFns } from "./MlbSavedLineup.vue?vue&type=template&id=6518edd8&scoped=true"
import script from "./MlbSavedLineup.vue?vue&type=script&lang=js"
export * from "./MlbSavedLineup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518edd8",
  null
  
)

export default component.exports